import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { BadgeCheckIcon } from 'lucide-react';
import { buyers } from '../data/pack';
export function FloatingNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [buyerIndex, setBuyerIndex] = useState(0);
  const reduceMotion = useReducedMotion();
  const buyer = buyers[buyerIndex];
  useEffect(() => {
    const openTimer = window.setTimeout(() => setIsVisible(true), 4500);
    const interval = window.setInterval(() => {
      setIsVisible(false);
      window.setTimeout(() => {
        setBuyerIndex(current => (current + 1) % buyers.length);
        setIsVisible(true);
      }, 800);
    }, 30000);
    return () => {
      window.clearTimeout(openTimer);
      window.clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-58" data-mp="2bvl6ioy3lcv5">
      {isVisible && <motion.aside initial={reduceMotion ? false : {
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={reduceMotion ? undefined : {
      opacity: 0,
      y: 10
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} aria-live="polite" className="fixed bottom-4 left-4 z-50 max-w-[calc(100vw-2rem)] md:bottom-7 md:left-7" data-id="element-59" data-mp="2fwwyv28cwc71">
          <div className="glass-panel flex gap-3 rounded-2xl border-brand-teal/25 bg-brand-paper/95 p-4 shadow-xl" data-id="element-60" data-mp="1d4pw4j585jw4">
            <span className="mt-0.5 rounded-full bg-brand-tealMist p-2" data-id="element-61" data-mp="138mt7b2jth84">
              <BadgeCheckIcon className="h-5 w-5 text-brand-teal" data-id="element-62" data-mp="136idzwz78vsj" />
            </span>
            <div data-id="element-63" data-mp="z5ylx7thgid9">
              <p className="text-xs text-brand-muted" data-id="element-64" data-mp="z8ksp58jutuf">
                Compra verificada · hace unos minutos
              </p>
              <p className="mt-1 text-sm text-brand-text" data-id="element-65" data-mp="kjjc0sgd6ac1">
                <strong data-id="element-66" data-mp="km5g2i41q7pi">{buyer.name}</strong> de {buyer.location} compró
              </p>
              <p className="mt-1 text-sm font-bold text-brand-teal" data-id="element-67" data-mp="omz3zbhhnmie">
                Atlas de Geometría Sagrada™
              </p>
            </div>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}